import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../config';

function BusinessNameSearch({ onSelect, initialValue }) {
  const [query, setQuery] = useState(initialValue || '');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    if (query.length < 3) {
      setResults([]);
      setShowResults(false);
      return;
    }

    const timer = setTimeout(() => {
      searchPlaces();
    }, 500);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const searchPlaces = async () => {
    setLoading(true);
    try {
      const fullUrl = `${API_URL}/places/search`;
      console.log('Searching places:', fullUrl, 'Query:', query);
      
      const response = await axios.get(fullUrl, {
        params: { query }
      });
      
      console.log('Search response:', response.data);
      setResults(response.data.places || []);
      // Only show results if user has interacted with the input
      if (hasInteracted) {
        setShowResults(true);
      }
    } catch (error) {
      console.error('Search error:', error.response?.data || error.message);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = async (place) => {
    setQuery(place.name);
    setShowResults(false);
    
    // Get detailed info
    try {
      const response = await axios.get(`${API_URL}/places/details/${place.placeId}`);
      onSelect({
        name: response.data.name,
        address: response.data.address,
        phone: response.data.phone || '',
        website: response.data.website || '',
        googleUrl: response.data.reviewUrl || response.data.googleUrl || '',  // Use reviewUrl for direct review form
        placeId: response.data.placeId || place.placeId  // Pass placeId
      });
    } catch (error) {
      console.error('Details error:', error);
      onSelect({
        name: place.name,
        address: place.address,
        placeId: place.placeId
      });
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={() => {
          setHasInteracted(true);
          if (results.length > 0) {
            setShowResults(true);
          }
        }}
        onBlur={() => {
          // Delay hiding to allow click on results
          setTimeout(() => setShowResults(false), 200);
        }}
        placeholder="Search for your business name..."
        style={{ width: '100%' }}
      />
      
      {loading && (
        <div style={{ padding: '8px', color: '#666', fontSize: '12px' }}>
          Searching...
        </div>
      )}

      {showResults && results.length > 0 && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: 'white',
          border: '1px solid #ddd',
          borderRadius: '8px',
          marginTop: '4px',
          maxHeight: '300px',
          overflowY: 'auto',
          zIndex: 1,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
        }}>
          {results.map((place, index) => (
            <div
              key={place.placeId || index}
              onClick={() => handleSelect(place)}
              style={{
                padding: '12px',
                cursor: 'pointer',
                borderBottom: index < results.length - 1 ? '1px solid #f0f0f0' : 'none',
                transition: 'background 0.2s',
                background: 'white'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
            >
              <div style={{ fontWeight: '500', marginBottom: '4px', color: '#333' }}>{place.name}</div>
              <div style={{ fontSize: '12px', color: '#666' }}>{place.address}</div>
              {place.rating && (
                <div style={{ fontSize: '12px', color: '#fbbc04', marginTop: '4px' }}>
                  ⭐ {place.rating}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {showResults && results.length === 0 && !loading && query.length >= 3 && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: 'white',
          border: '1px solid #ddd',
          borderRadius: '8px',
          marginTop: '4px',
          padding: '12px',
          zIndex: 10000,
          color: '#666',
          fontSize: '14px'
        }}>
          No results found
        </div>
      )}
    </div>
  );
}

export default BusinessNameSearch;
